import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import React from 'react'

const DeleteConfirmModal = ({
  isOpen,
  onClose,
  onSubmit,
  deleteString,
  children,
  titleOverride,
  buttonString,
  cancelString,
  buttonDisabled = false,
}) => {
  return (
    <Dialog open={isOpen}>
      <DialogTitle>
        {titleOverride
          ? titleOverride
          : `Are you sure you want to delete ${deleteString}?`}
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant={'outlined'}>
          {cancelString ? cancelString : 'Cancel'}
        </Button>
        <Button
          disabled={buttonDisabled}
          onClick={onSubmit}
          variant={'contained'}
          color={'warning'}
        >
          {buttonString ? buttonString : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteConfirmModal
